<div class="sub-header">
  <div class="container-header">
    <div (click)="navegarParaHome()" style="cursor: pointer !important">
      <img src="assets/icons/arrowBack.svg" alt="" />
    </div>

    <span class="fs-4 sub-header__title">{{ title }}</span>
  </div>
</div>
